<template>
    <h2>Product Modals</h2>
    <router-view />
</template>

<script>
export default {
    
}
</script>